import React from 'react';
import './InactivityWarning.css';

interface InactivityWarningProps {
  secondsLeft: number;
  onStay: () => void;
  onLogout: () => void;
}

export const InactivityWarning: React.FC<InactivityWarningProps> = ({
  secondsLeft,
  onStay,
  onLogout,
}) => {
  const minutes = Math.floor(secondsLeft / 60);
  const secs = secondsLeft % 60;
  const timeDisplay =
    minutes > 0
      ? `${minutes}:${secs.toString().padStart(2, '0')}`
      : `${secs}s`;

  return (
    <div className="inactivity-backdrop" role="dialog" aria-modal="true" aria-label="Session timeout warning">
      <div className="inactivity-card">
        <div className="inactivity-icon">⏳</div>
        <h2 className="inactivity-title">Session Inactive</h2>
        <p className="inactivity-message">
          Your session has been inactive for 25 minutes. You will be automatically logged out in{' '}
          <span className="inactivity-countdown">{timeDisplay}</span>.
        </p>
        <div className="inactivity-actions">
          <button className="inactivity-btn inactivity-btn-stay" onClick={onStay}>
            I'm still here
          </button>
          <button className="inactivity-btn inactivity-btn-logout" onClick={onLogout}>
            Logout
          </button>
        </div>
      </div>
    </div>
  );
};
